export default "__VITE_ASSET__G7X3o5GG__"